import React, { useEffect, useState } from 'react';
import { getPerformance } from '../api/mongoServices';

const PerformanceModal = ({ number, name, onClose }) => {
  const [metrics, setMetrics] = useState(null);

  useEffect(() => {
    (async () => {
      const data = await getPerformance(number);
      setMetrics(data);
    })();
  }, [number]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg p-6 w-[450px]">
        <h3 className="text-xl font-bold mb-2">Performance: {name}</h3>
        {metrics ? (
          <>
            <p>Weekly Bookings: <strong>{metrics.weeklyBets}</strong></p>
            <p>Total Points Played: <strong>{metrics.totalPoints}</strong></p>
            <p>Contribution to Total: <strong>{metrics.contribution}%</strong></p>
          </>
        ) : (
          <p>Loading performance data...</p>
        )}
        <div className="flex justify-end mt-4">
          <button className="px-4 py-2 bg-gray-600 text-white rounded" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default PerformanceModal;
